module.exports = __webpack_public_path__ + "static/media/exhibition-services-img6.bb429820.jpg";